export default __webpack_public_path__ + "static/media/tablet.49328f28.png";